// extracted by mini-css-extract-plugin
module.exports = {"cls1":"about-RightSide-module--cls1--208xQ","cls2":"about-RightSide-module--cls2--1EA6z about-RightSide-module--cls1--208xQ"};